// @ts-nocheck
import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import {CurrencyCircleDollar, WarningCircle} from "@phosphor-icons/react";
import {useTranslation} from "react-i18next";
import {BaseSpinner} from "@/components";
import useGetUserWallet from "../../../hooks/wallet/useGetUserWallet";

const TransferAmount = ({setTransferAmount, setIsNextDisabled}) => {
  const {isLoading, balance} = useGetUserWallet();
  const [error, setError] = useState("");
  const [focused, setFocused] = useState(false);
  const {t} = useTranslation();

  useEffect(() => {
    setIsNextDisabled?.(true);
  }, [setIsNextDisabled]);

  const handleChange = e => {
    const value = e.target.value;
    const numberRegex = /^\d*\.?\d*$/;
    if (value.trim() === "") {
      setError("");
      setIsNextDisabled?.(true);
      return;
    }
    if (!numberRegex.test(value)) {
      setError(t("transferStepsAmountError"));
      setIsNextDisabled?.(true);
      return;
    }
    const amount = Number.parseFloat(value);
    if (!balance) {
      setError(t("transferStepsAmountError2"));
      setIsNextDisabled?.(true);
      return;
    }
    if (amount > balance.balance) {
      setError(t("transferStepsAmountError2"));
      setIsNextDisabled?.(true);
      return;
    }
    if (Number.isNaN(amount) || amount <= 0) {
      setError(t("transferStepsAmountError"));
      setIsNextDisabled?.(true);
      return;
    }
    setTransferAmount(amount);
    setError("");
    setIsNextDisabled?.(false);
  };

  return (
    <div style={{display: "flex", flexDirection: "column", alignItems: "stretch", gap: 12}}>
      <h4 style={{fontWeight: 700, fontSize: 16, margin: 0, color: "#fff", textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center", gap: 8}}>
        <CurrencyCircleDollar size={20} color="#d732a8" weight="fill" />
        {t("transferStepsTransferAmount")}
      </h4>

      {isLoading && <BaseSpinner size="lg" />}

      {!isLoading && balance && (
        <p style={{textAlign: "center", fontSize: 13, margin: 0, color: "rgba(215,50,168,0.75)"}}>
          Saldo disponible: <b style={{color: "#d732a8"}}>Bs. {balance.balance}</b>
        </p>
      )}

      {!isLoading && error && (
        <div style={{display: "flex", alignItems: "center", justifyContent: "center", gap: 6}}>
          <WarningCircle size={16} color="var(--color-danger)" weight="fill" />
          <p style={{color: "var(--color-danger)", fontSize: 13, margin: 0}}>{error}</p>
        </div>
      )}

      {!isLoading && (
        <div style={{display: "flex", justifyContent: "center", marginTop: 8}}>
          <div
            style={{
              position: "relative",
              width: "100%",
              maxWidth: 320,
              borderRadius: 999,
              boxShadow: focused ? "0 0 0 2px #d732a8, 0 0 16px rgba(215,50,168,0.3)" : "none",
              transition: "box-shadow 0.2s",
            }}
          >
            <input
              type="text"
              inputMode="decimal"
              pattern="[0-9]*"
              placeholder={t("transferStepsTransferAmountInput")}
              onChange={handleChange}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              style={{
                width: "100%",
                height: 48,
                borderRadius: 999,
                border: `1.5px solid ${focused ? "#d732a8" : error ? "var(--color-danger)" : "rgba(215,50,168,0.3)"}`,
                background: "rgba(215,50,168,0.06)",
                color: "#fff",
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "inherit",
                padding: "0 56px 0 20px",
                outline: "none",
                boxSizing: "border-box",
                transition: "border-color 0.2s",
              }}
            />
            <span
              style={{
                position: "absolute",
                right: 20,
                top: "50%",
                transform: "translateY(-50%)",
                fontWeight: 600,
                fontSize: 15,
                color: focused ? "#d732a8" : "rgba(255,255,255,0.35)",
                pointerEvents: "none",
                transition: "color 0.2s",
              }}
            >
              Bs
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

TransferAmount.propTypes = {
  setTransferAmount: PropTypes.func.isRequired,
  setIsNextDisabled: PropTypes.func,
};

export default TransferAmount;
